<template>
  <v-dialog v-model="dialog" max-width="1100px" scrollable>
    <template v-slot:activator="{ on }">
      <v-row>
        <v-col class="py-0">
          <mf-button :loading="$apollo.queries.tree.loading" :label="configuration.title" v-on:click.native="on.click" />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="py-0">
          <span class="texto-corrido-pequeno">{{ configuration.undertext }}</span>
        </v-col>
      </v-row>
    </template>
    <v-card>
      <v-card-title>
        <span class="mf-h6 primary-text">{{ configuration.title }}</span>
      </v-card-title>
      <v-card-text>
        <tree :key="treeRenderKey" :tree="tree" :level-labels="treeLabels" :selected-items.sync="localSelected" />
        <mf-action-buttons
          :primary-button="{
            text: 'Selecionar',
            action: confirmSelection,
            isVisible: true,
            isDisabled: disableSave,
            tooltip: tooltipPrimaryButton,
            tooltipMessage: tooltipPrimaryButtonMessage,
          }"
          :extra-button="{
            text: 'Cancelar',
            action: () => (dialog = false),
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import { QUERY_NEIGHBORHOODS } from '@/components/geo-selectors/graphql'
// TODO: Possible optimization - change the query depending on the type would reduce network load
export default {
  components: {
    Tree: () => import('@/components/tree/Tree.vue'),
  },
  props: {
    selected: Array,
    type: {
      type: String,
      required: true,
      validator: (val) => ['federative_unit', 'city', 'neighborhood'].includes(val),
    },
    disableSave: {
      type: Boolean,
      default: false,
    },
    tooltipPrimaryButton: {
      type: Boolean,
      default: false,
    },
    tooltipPrimaryButtonMessage: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    dialog: false,
    localSelected: [],
    confirmedSelected: [],
    treeRenderKey: 0,
    treeLabels: ['País', 'Estado', 'Cidade', 'Bairro'],
  }),
  computed: {
    showsCities() {
      return ['city', 'neighborhood'].includes(this.type)
    },
    showsNeighborhoods() {
      return ['neighborhood'].includes(this.type)
    },
    configuration() {
      const configurations = {
        federative_unit: {
          title: 'Selecionar Estados',
          undertext: `${this.confirmedSelected.length} estado(s) selecionados`,
        },
        city: {
          title: 'Selecionar Cidades',
          undertext: `${this.confirmedSelected.length} cidade(s) selecionadas`,
        },
        neighborhood: {
          title: 'Selecionar Bairros',
          undertext: `${this.confirmedSelected.length} bairro(s) selecionados`,
        },
      }
      return configurations[this.type]
    },
  },
  apollo: {
    tree: {
      query: QUERY_NEIGHBORHOODS,
      update({ geolocationTree }) {
        const tree = {
          children: geolocationTree.countries.map((country) => ({
            level: 1,
            id: country.id,
            name: country.name,
            selectable: this.type === 'federative_unit',
            children: country.federative_units.map((federative_unit) => ({
              level: 2,
              id: federative_unit.id,
              name: federative_unit.name,
              selectable: this.type === 'city' || this.type === 'federative_unit',
              isLeaf: this.type === 'federative_unit',
              children:
                this.showsCities &&
                federative_unit.cities.map((city) => ({
                  level: 3,
                  id: city.id,
                  name: city.name,
                  selectable: this.type === 'city' || this.type === 'neighborhood',
                  isLeaf: this.type === 'city',
                  children:
                    this.showsNeighborhoods &&
                    city.neighborhoods.map((neighborhood) => ({
                      level: 4,
                      id: neighborhood.id,
                      name: neighborhood.name,
                      selectable: this.type === 'neighborhood',
                      isLeaf: this.type === 'neighborhood',
                    })),
                })),
            })),
          })),
        }
        return tree
      },
    },
  },
  watch: {
    dialog(value) {
      if (value) {
        this.setup()
        this.treeRenderKey += 1
      }
    },
  },
  mounted() {
    this.setup()
  },
  methods: {
    confirmSelection() {
      this.confirmedSelected = this.localSelected
      this.$emit('update:selected', this.confirmedSelected)
      this.dialog = false
    },
    setup() {
      if (this.selected) {
        this.confirmedSelected = cloneDeep(this.selected)
      }
      this.localSelected = cloneDeep(this.confirmedSelected)
    },
  },
}
</script>
